export default {
    messages: {
        en: {
            home: 'Home',
            book: 'My Books',
            portfolio: 'Portfolio',
            resume: 'Résumé',
            contact: 'Contact',
            notFound: 'This page does not exist.'
        },
        de: {
            home: 'Home',
            book: 'Meine Bücher',
            portfolio: 'Portfolio',
            resume: 'Résumé',
            contact: 'Kontakt',
            notFound: 'Diese Seite existiert nicht.'
        }
    }
}